import styled, { css } from 'styled-components';

import { BREAKPOINTS } from '@/constants/breakpoints';

import { ColTypes } from './AdsList.types';

export const gridConfig = (config: ColTypes) => {
  return css`
    ${config.xxl &&
    css`
      @media (min-width: ${BREAKPOINTS.largeDesktop}) {
        grid-template-columns: repeat(${config.xxl}, 1fr);
      }
    `}

    ${config.xl &&
    css`
      @media (min-width: ${BREAKPOINTS.desktop}) {
        grid-template-columns: repeat(${config.xl}, 1fr);
      }
    `}

    ${config.lg &&
    css`
      @media (max-width: ${BREAKPOINTS.laptop}) {
        grid-template-columns: repeat(${config.lg}, 1fr);
      }
    `}


    ${config.md &&
    css`
      @media (max-width: ${BREAKPOINTS.tablet}) {
        grid-template-columns: repeat(${config.md}, 1fr);
      }
    `}

    ${config.sm &&
    css`
      @media (max-width: ${BREAKPOINTS.mobile}) {
        grid-template-columns: repeat(${config.sm}, 1fr);
      }
    `}
  `;
};

export const ListWrapper = styled.div<{ $cols?: ColTypes }>`
  width: 100%;
  height: fit-content;
  padding: 30px 0 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(305px, 1fr));
  gap: 20px;

  @media (max-width: ${BREAKPOINTS.mobile}) {
    padding: 20px 0 0;
    grid-template-columns: repeat(auto-fill, minmax(345px, 1fr));
  }

  ${({ $cols }) => $cols && gridConfig($cols)}
`;
